
import React from 'react';
import TranslatedText from '@/TranslatedText';

const SupportHero = () => {
  return (
    <div className="text-center mb-16">
      <h1 className="text-4xl font-bold text-ahavex-blue mb-6">
        <TranslatedText text="How Can We Help You?" />
      </h1>
      <p className="text-lg text-gray-600 max-w-3xl mx-auto">
        <TranslatedText 
          text="Our support team is here to assist you with any questions or issues you might have. Browse through our resources or get in touch directly." 
        />
      </p>
    </div>
  );
};

export default SupportHero;
